import Icon from "@expo/vector-icons/MaterialIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";

const withOpacity = (rgbColor: string, opacity: number) => {
	return rgbColor.replace("rgb", "rgba").replace(")", `, ${opacity})`);
};

type SkillItem = {
	id: string;
	icon: keyof typeof Icon.glyphMap;
	label: string;
};

const SKILLS: SkillItem[] = [
	{ id: "reading", icon: "auto-stories", label: "onboarding.skills.reading" },
	{ id: "listening", icon: "hearing", label: "onboarding.skills.listening" },
	{ id: "speaking", icon: "mic-none", label: "onboarding.skills.speaking" },
	{
		id: "writing",
		icon: "drive-file-rename-outline",
		label: "onboarding.skills.writing",
	},
];

const OnboardingSkills = () => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box gap={32}>
			<Box flexDirection="row" flexWrap="wrap" gap={8}>
				{SKILLS.map((skill) => (
					<Box
						key={skill.id}
						width="48%"
						backgroundColor={theme.colors.elevation.level2}
						paddingHorizontal={24}
						paddingVertical={16}
					>
						<Box alignItems="center" gap={8}>
							<Box
								padding={6}
								borderRadius={60}
								borderWidth={1}
								borderColor={withOpacity(theme.colors.primary, 0.05)}
							>
								<Box
									padding={6}
									borderRadius={50}
									borderWidth={1}
									borderColor={withOpacity(theme.colors.primary, 0.1)}
								>
									<Box
										width={76}
										height={76}
										borderRadius={38}
										justifyContent="center"
										alignItems="center"
										backgroundColor={theme.colors.elevation.level5}
										borderColor={withOpacity(theme.colors.primary, 0.15)}
									>
										<Icon
											name={skill.icon}
											size={40}
											color={theme.colors.primary}
										/>
									</Box>
								</Box>
							</Box>
							<Text
								variant="titleMedium"
								style={{ color: theme.colors.primary, textAlign: "center" }}
							>
								{t(skill.label)}
							</Text>
						</Box>
					</Box>
				))}
			</Box>
			<Text
				variant="bodyLarge"
				style={{
					color: theme.palette.text.secondary,
					textAlign: "center",
					paddingHorizontal: 16,
				}}
			>
				{t("onboarding.steps.skills.bottomLabel")}
			</Text>
		</Box>
	);
};

export default OnboardingSkills;
